// The Users page's sub-pages: the users board and the two worklists
// (Customer Mismatches, Duplicate Emails). The tab is kept in the URL
// (`users-tab`) so a link to a worklist can be shared.
export const USER_TABS_ID = "users"
export const USER_VIEW_ALL = "all"
export const USER_VIEW_CUSTOMER_MISMATCHES = "customer-mismatches"
export const USER_VIEW_EMAIL_DUPLICATES = "duplicate-emails"

/** The Users page landed on the Customer Mismatches worklist (same `${id}-tab` param Tabs persists, tabs.utils). */
export const USER_CUSTOMER_MISMATCHES_HREF = `/users?${USER_TABS_ID}-tab=${USER_VIEW_CUSTOMER_MISMATCHES}`

// A user's app language (Configuration.ActiveLanguageCode): the full BCP-47
// codes the runtime supports (common.Languages.IsSupported). Distinct from
// the invitation module's LANGUAGE_OPTIONS, which are the short email-content
// languages ("nb"/"en") — the backend normalizes both shapes, but the user
// editor should show exactly what gets stored.
export const USER_LANGUAGE_OPTIONS = [
  { value: "nb-NO", label: "Norwegian (Bokmål)" },
  { value: "nn-NO", label: "Norwegian (Nynorsk)" },
  { value: "en-GB", label: "English" },
  { value: "sv-SE", label: "Swedish" },
  { value: "da-DK", label: "Danish" },
]

// Reads ActiveLanguageCode out of a user's Configuration JSON blob (typed as
// unknown/JSONObject on the wire). Empty string = not set.
export function getUserActiveLanguageCode(configuration: unknown) {
  if (typeof configuration !== "object" || configuration === null) return ""
  const value = (configuration as { ActiveLanguageCode?: unknown })
    .ActiveLanguageCode
  return typeof value === "string" ? value : ""
}

// Display label for a stored language code; falls back to the raw code so an
// unexpected value is still visible rather than blank.
export function getUserLanguageLabel(code: string) {
  return (
    USER_LANGUAGE_OPTIONS.find((option) => option.value === code)?.label ?? code
  )
}
